<template>
<div :class="single ? 'col-md-6 mb-4' : 'w-100 mb-4'" class="roster-leave-policies-page" v-if="modules.length > 0 && $acl['employee/bulk'] == 2">
  <div :class="single ? 'clearfix company-form-container h-100 pb-3' : 'clearfix h-100'" class="employee-tab-inner">
    <div class="row no-gutters py-3">
          <div class="col-6 px-3 company-form-box-title">Approver</div>
          <div class="col-6 px-3 text-right company-form-box-title" v-if="single ? (current_module > 0) : (selected_modules.length > 0)">
              <a @click="addSelect()" class="edit-icon cursor-pointer"><i class="fas fa-plus"></i></a>
          </div>
      </div>

      <b-overlay :show="showoverlay_list" rounded="sm">
        <ul class="bank-info mt-2">
          <li class="m-0 px-3 py-2">
              <div class="title px-0">Module:</div>
                <div class="text">
                  <template v-if="single">
                    <b-form-select class="w-100" id="approvers_depth" name="approvers_depth" @input="getSelect" v-model="current_module" :options="modules"></b-form-select>
                  </template>
                  <template v-else>
                    <div class="position-relative" ref="module_dropdown">
                      <button type="button" class="form-control d-flex justify-content-between align-items-center text-left overflow-hidden bg-white cursor-pointer assignment-toggle" @click.prevent="toggleModuleDropdown">
                        <span
                          class="assignment-toggle-label d-block overflow-hidden"
                          :class="selected_modules && selected_modules.length ? 'has-selection' : 'is-placeholder'"
                        >
                          {{ selected_modules && selected_modules.length ? getSelectedModuleNames() : 'Select Modules' }}
                        </span>

                        <b-icon class="ml-3 assignment-toggle-caret custom-caret" icon="chevron-down"></b-icon>
                      </button>

                      <div class="assignment-menu position-absolute rounded p-2 bg-white ibox" v-if="openModuleDropdown">
                        <label v-for="mod in modules" :key="mod.value" class="assignment-option d-flex align-items-center cursor-pointer p-1 m-0 font-weight-normal rounded">
                          <input class="assignment-checkbox" type="checkbox" :value="mod.value" v-model="selected_modules"/>
                          <span>{{ mod.text }}</span>
                        </label>
                      </div>
                    </div>
                  </template>
                </div>
              <div class="action"></div>
          </li>

          <li class="m-0 px-3 py-2" v-for="(item, index) in selects" :key="index">
            <div class="title d-flex align-items-center px-0">Level {{ index + 1 }} Approver:</div>
            <div class="text">
                <approver-searchable-select class="mb-0" :exclude="excludeList" :searchQuery="item" department="" @update="updateSelect(index, $event)" ></approver-searchable-select>
            </div>
            <div class="action d-flex align-items-center">
              <b-button class="rounded py-1 float-right" size="sm" variant="outline-danger" title="Unselect Approver" @click="removeSelect(index)">
                <b-icon icon="trash" aria-hidden="true"></b-icon>
              </b-button>
            </div>
          </li>

        </ul>

        <div class="px-3 pb-3 d-flex justify-content-center" v-if="show_save">
            <b-button type="submit" class="rounded py-1" variant="primary" @click="saveSelect">Save</b-button>
        </div>
      </b-overlay>

  </div>
</div>

</template>

<script>
export default {
  props: ['single' , 'employee_ids'],
  data() {
    return {
      show_save: false,
      showoverlay_list: false,
      selects: [],
      approver_list: [],
      exclude:[],
      modules : [],
      current_module:0,
      selected_modules: [],
      openModuleDropdown: false,
    };
  },
  methods: {
    getSettings() {
        Promise.all([
        axios.get(this.$api_url + '/approver/settings/1'),
        axios.get(this.$api_url + '/approver/settings/2'),
        axios.get(this.$api_url + '/approver/settings/3'),
        axios.get(this.$api_url + '/approver/settings/4'),
        ]).then(([mod1, mod2, mod3, mod4]) => {
        if (mod1.data['status'] == 1) {
            this.modules.push({ value: 1, text: 'Leave' });
        }

        if (mod2.data['status'] == 1) {
            this.modules.push({ value: 2, text: 'Attendance Mobility' });
        }

        if (mod3.data['status'] == 1) {
            this.modules.push({ value: 3, text: 'Attendance Adjustment' });
        }
        if (mod4.data['status'] == 1) {
            this.modules.push({ value: 4, text: 'Swap' });
        }

        if (this.modules.length > 0) {
            this.current_module = this.modules[0].value;
            this.selected_modules = [];
            this.getSelect();
        }
        });
    },
    addSelect() {
      this.show_save = true;
      this.selects.push({ value: '', text: '' });
    },
    removeSelect(index) {
      this.show_save = true;
      this.selects.splice(index, 1);
    },
    updateSelect(index, newValue) {
      this.$set(this.selects, index, newValue);
      this.show_save = true;
    },
    getSelect() {
      this.show_save = false;
      this.approver_list = [];
      let moduleId = this.single ? this.current_module : (this.selected_modules.length > 0 ? this.selected_modules[0] : 0);
      if (moduleId === 0) {
        this.selects = [];
        this.approver_list = [];
        return;
      }
      axios.get(this.$api_url + '/approver/list/' + moduleId).then(response => {
                this.selects = response.data;
                this.approver_list = response.data;
            }).catch(error => {
                this.serverError(error);
            });
    },
    saveSelect() {

        let empty = this.selects.filter(({value}) => value == '');
        if(empty.length > 0){
          this.$bvToast.toast('Incorrect Employee Selected',{
            solid: true,
            title: 'Failed',
            variant: 'danger',
          });
          return;
        }

        let valuesToSend = this.selects.map(item => item.value);
        this.showoverlay_list = true;

        let modulesToSave = [];
        if (this.single) {
          modulesToSave = [this.current_module];
        } else {
          modulesToSave = this.selected_modules;
        }

        if (modulesToSave.length === 0) {
          this.$bvToast.toast('No Module Selected', {
            solid: true,
            title: 'Failed',
            variant: 'danger',
          });
          this.showoverlay_list = false;
          return;
        }

        let requests = modulesToSave.map(moduleId => {
          let formData = new FormData();
          formData.append('selects', JSON.stringify(valuesToSend));
          formData.append('employee_ids', JSON.stringify(this.employee_ids));
          return axios.post(this.$api_url + '/approver/list/' + moduleId, formData);
        });

        Promise.all(requests).then(responses => {
            this.$bvToast.toast('Saved!', {
                        title: `Success`,
                        variant: 'success',
                        solid: true
                    });
            this.showoverlay_list = false;
            this.$emit('event');
        }).catch(error => {
            this.showoverlay_list = false;
            this.serverError(error);
        });

    },
    toggleModuleDropdown() {
      this.openModuleDropdown = !this.openModuleDropdown;
    },
    getSelectedModuleNames() {
      let names = [];
      let selectedIds = Array.isArray(this.selected_modules)
          ? this.selected_modules.map(x => parseInt(x))
          : [];

      for (let i = 0; i < this.modules.length; i++) {
        let item = this.modules[i];

        if (selectedIds.includes(parseInt(item.value))) {
          names.push(item.text);
        }
      }

      return names.join(", ");
    },
    handleClickOutside(event) {
      let dropdown = this.$refs.module_dropdown;
      if (!dropdown) return;
      if (!dropdown.contains(event.target)) {
        this.openModuleDropdown = false;
      }
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  created() {
    this.getSettings();
  },
  watch: {
    selected_modules: {
      handler(newVal, oldVal) {
        if (!this.single) {
          let newPrimary = newVal && newVal.length > 0 ? newVal[0] : 0;
          let oldPrimary = oldVal && oldVal.length > 0 ? oldVal[0] : 0;
          if (newPrimary !== oldPrimary) {
            this.getSelect();
          }
        }
      },
      deep: true
    }
  },
  computed: {
    excludeList() {
      let selects = this.selects.filter(s => s.value).map(s => s.value);
      return selects.concat(this.employee_ids);
    }
  },
};
</script>
